define("SuiteDB.SDBFeatureItems.SDBFeatureItems", [
  "SuiteDB.SDBFeatureItems.SDBFeatureItems.View",
], function (SDBFeatureItemsView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      // Enhance the view's getContext method to include configuration
      SDBFeatureItemsView.prototype.getContext = _.wrap(
        SDBFeatureItemsView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          context.linkBtn = SC.CONFIGURATION.SDBFeatureItems.link;
          context.text = SC.CONFIGURATION.SDBFeatureItems.text;
          return context;
        }
      );

      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      if (layout) {
        layout.addChildView("feature_items_home", function () {
          return new SDBFeatureItemsView({ container: container });
        });
      }
    },
  };
});
